import axios from "axios";
import { decryptApiHubData, encryptApiHubData } from "./helpers/encryptors";

const client = axios.create({
    baseURL: process.env.REACT_APP_BASEURL,
});
client.defaults.headers.common['Authorization'] = 'Basic QUYyNDI5RUQtMEQyRC00NjEwLTlCMjQtQzgwODJCMUEyQTg2OjdFM0JERjlCLUJGQUMtNEUwRi1BQzk1LTk5Q0VDQTY2MzQ5Nw==';

export const verifyImage = async(payload) => {
    const res =  axios.post(process.env.REACT_APP_VERIFY_IMAGE,payload)
    return res
  
}

export const verifyImageTest = async(payload) => {
    const res =  axios.post(process.env.REACT_APP_VERIFY_IMAGE_TEST, payload)
   
}

export const verifyCard = async(payload) => {
    const token = await encryptApiHubData(payload);
    const res =  await client.post(process.env.REACT_APP_VERIFYACCOUNT, {
        Data: token,
      });
    const data = res?.data;
  if (data && typeof data.EncryptedPayload === "string") {
  
    const decrypted = await decryptApiHubData(data.EncryptedPayload).catch(() => null);
 


    return decrypted ?? data; // fallback to raw if decrypt fails
  }

  return data;
}
export const requestOtp = async(payload) => {
    const token = await encryptApiHubData(payload);
    const res = await client.post(process.env.REACT_APP_REQUESTOTP, {
        Data: token,
      });
      const data = res?.data;

      if (data && typeof data.EncryptedPayload === "string") {
      
        const decrypted = await decryptApiHubData(data.EncryptedPayload).catch(() => null);
   

    
        return decrypted ?? data; // fallback to raw if decrypt fails
      }
    
      return data;
}
export const sendDetails = async(payload) => {
    const token = await encryptApiHubData(payload);
 
   const res = await  client.post(process.env.REACT_APP_SUBMITDETAILS, {
        Data: token,
      })
      const data = res?.data;
      if (data && typeof data.EncryptedPayload === "string") {
      
        const decrypted = await decryptApiHubData(data.EncryptedPayload).catch(() => null);
    
  
        return decrypted ?? data; // fallback to raw if decrypt fails
      }
 
      return data;
}